/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
/* eslint-disable */
import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';
import _ from 'lodash';
import { toJS } from 'mobx';

const tenantRolePermissions = types.model('TenantRolePermissions', {
  tenantId: types.maybeNull(types.string),
  roles: types.maybeNull(types.array(types.integer), []),
  permissions: types.maybeNull(types.array(types.string), [])
});

const UserRolePermissions = types.model('UserRolePermissions', {
  isSuperAdmin: types.maybeNull(types.boolean),
  superPermissions: types.maybeNull(types.array(types.string), []),
  tenantPermissions: types.optional(types.array(tenantRolePermissions), [])
});

const UsersPermissions = types
  .model('UsersPermissions', {
    userPermissionDetail: types.optional(UserRolePermissions, {}),
    selectedPermissions: types.optional(types.array(types.string), [])
  })
  .actions((self) => ({
    fetchPermissions(id) {
      Framework.getEventManager().publish(constants.GET_USERS_PERMISSIONS, { id });
    },
    setPermissions(response) {
      applySnapshot(self.userPermissionDetail, response?.data);
      Framework.getEventManager().publish(constants.USERS_PERMISSIONS_FETCHED, {});
    },
    setSelectedPermissions(tenantId) {
      const superAdminConfig = self.userPermissionDetail.isSuperAdmin;

      if (superAdminConfig) {
        const data = toJS(self.userPermissionDetail.superPermissions);
        applySnapshot(self.selectedPermissions, data);
      } else {
        const tenantConfig = self.userPermissionDetail?.tenantPermissions.find((item) => item.tenantId === tenantId);

        if (tenantConfig && tenantConfig.permissions) {
          const data = toJS(tenantConfig.permissions);
          applySnapshot(self.selectedPermissions, data);
        } else {
          // Clear permissions if tenant not found or has no permissions
          applySnapshot(self.selectedPermissions, [constants.permissions.NO_ACCESS_RESTRICTED]);
        }
      }
    }
  }));
export default UsersPermissions;
